import {
  executeTwoStepQuery,
  fetchJsonByGet,
  fetchJsonByPost,
  fetchJsonByPut,
  fetchTextByPost,
  noResponseDelete,
} from './execute';
import { getParams } from '../reducers/analyticsApp';
import { toCompound } from '../converters/compoundConverter';
import {
  buildFunnelQuery,
  fromFunnelExecuteResponse,
  fromFunnelResponse,
  getFunnelInfo,
  getFunnelsInfo,
} from '../converters/funnelApiConverter';
import {
  buildDashboardFunnelQuery,
  fromFunnelDashbordResponse,
} from '../converters/funnelDashboardApiConverter';

const executeFunnel = (query, params) => fetchJsonByPost('/funnels/query', query, params);

export const executeDashboardFunnelQuery = (unit, executeId) => (dispatch, getState) => {
  const query = buildDashboardFunnelQuery(getState(), unit);
  return executeTwoStepQuery(executeFunnel, query, executeId, dispatch, getState).then((response) =>
    fromFunnelDashbordResponse(response, query, unit)
  );
};

export const executeFunnelQuery = (executeId) => (dispatch, getState) => {
  const state = getState();
  const query = buildFunnelQuery(state);
  const funnelInfo = getFunnelInfo(state);

  return executeTwoStepQuery(executeFunnel, query, executeId, dispatch, getState).then((response) =>
    fromFunnelExecuteResponse(response, query, funnelInfo)
  );
};

export const exposeFunnelQuery = () => (dispatch, getState) =>
  fetchTextByPost(
    '/funnels/query/expose',
    buildFunnelQuery(getState()),
    getParams(getState())
  ).then((response) => ({ sql: response }));

export const getFunnels = () => (dispatch, getState) => {
  const state = getState();
  const funnelsInfo = getFunnelsInfo(state);

  return fetchJsonByGet('/funnels/list?full=true', getParams(state)).then((response) => ({
    funnels: response.map((r) => fromFunnelResponse(r, funnelsInfo)),
  }));
};

export const createFunnel = (funnel) => (dispatch, getState) => {
  const state = getState();
  const funnelsInfo = getFunnelsInfo(state);

  return fetchJsonByPost('/funnels', toCompound(funnel), getParams(state)).then((response) => ({
    funnel: fromFunnelResponse(response, funnelsInfo),
  }));
};

export const updateFunnel = (funnel, id) => (dispatch, getState) => {
  const state = getState();
  const funnelsInfo = getFunnelsInfo(state);

  return fetchJsonByPut('/funnels', toCompound(funnel), getParams(state)).then((response) => ({
    funnel: fromFunnelResponse(response, funnelsInfo),
    id,
  }));
};

export const deleteFunnel = (id) => (dispatch, getState) =>
  noResponseDelete(`/funnels/${id}`, getParams(getState())).then(() => ({ id }));
